/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK datasyncmanager Adaptor
 * Functions for calling datasyncmanager APIs.
 ************************************************************/

var q = require('q');
var request = require('superagent');
var Agent = require('agentkeepalive');

var helpers = require('../../helpers');
var DLSError = helpers.errors.DLSError;

/*********************************
 * Setting Up Module Entry Point
 **********************************/
module.exports = datasyncmanager;

var keepaliveAgent = new Agent({
  timeout: 60000,
  freeSocketTimeout: 30000
});

function datasyncmanager(accountId) {
  this.accountId = accountId;

  return {
    createDataSyncManager: createDataSyncManager.bind(this),
    updateDataSyncManager: updateDataSyncManager.bind(this),
    deleteDataSyncManager: deleteDataSyncManager.bind(this),
    getParticularDataSyncManager: getParticularDataSyncManager.bind(this),
    getAllDataSyncManagersOfAGroup: getAllDataSyncManagersOfAGroup.bind(this)
  };
}

/**
 * options = {
 * "*body": {
 *  "*dsmid": "string",
 *  "dsm_groupid": "string",
 *  "rules_orgs": [{"*id": "string"}, ...],
 *  "rules_products": [{
 *    "*productcode": "string",
 *    "*ext_entitlement_meta": { "start_date", "*end_date" },
 *    "*target_roles": [role]
 *  }],
 *  "*category": "entitlement_sync",
 *  "*type": "managed",
 *  "*ext_user_id": "string",
 *  "data": {},
 *  "*audit": true
 * }
 */
function createDataSyncManager(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  if(options && options.body) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.createDataSyncManager;
    url = helpers.api.constructAPIUrl(url, {
      accountid: self.accountId
    });

    var requestAPI = request.post(url)
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .send(options.body);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if(error) {
          var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
    });
  } else {
    var err = {};
    err.message = err.description = 'Mandatory param - body ' +
                                    'not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }

  return dfd.promise;
 }

/**
 * options = {
 *   "*dsmid": "datasyncmanagerid",
 *   "*body": {
 *     "rules_orgs": [{ "*id": "orgid" }, ...],
 *     "*rules_products": [{
 *       "*productcode": "<productcode-1>",
 *       "*ext_entitlement_meta": { "start_date", "*end_date" },
 *       "target_roles": ["role"],
 *     }],
 *     "*ext_user_id": "ext_actor_id",
 *     "data": {},
 *     "*audit": <boolean>
 *   }
 * }
 */
function updateDataSyncManager(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  if (options && options.dsmid && options.body) {
    // Passed all validations, Contruct API url
    var adaptor = self.config.DEFAULT_HOSTS.AUTH,
      apiPath = self.config.AUTH_API_URLS.dataSyncManager,
      url = adaptor + apiPath;

    url = helpers.api.constructAPIUrl(url, {
      accountid: self.accountId, dsmid: options.dsmid
    });

    var params = options.body;
    // Setup request with URL and Params
    var requestAPI = request.put(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(params);

    if (self.traceid) {
      requestAPI.set('X-Amzn-Trace-Id', self.traceid);
    }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
  } else {
    var error = {};
    error.message = error.description = 'Mandatory params: dsmid, body not found in the request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}

/**
 * options = {
 * "*dsmid": "string",
 * "*body": {
 *  "*ext_user_id": "string",
 *  "*audit": true
 * }
 */
function deleteDataSyncManager(options) {
  var self = this;
  var dfd = q.defer();

  if(options && options.dsmid && options.body) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.dataSyncManager;
    url = helpers.api.constructAPIUrl(url, { accountid: self.accountId, dsmid: options.dsmid });

    // Setup request with URL and Params
    var requestAPI = request.delete(url)
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .send(options.body);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function (error, response) {
        if(error) {
          var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
    });
  }
  else {
    var err = {};
    err.message = err.description = 'Mandatory params - dsmid or body' +
                                    ' not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }

  return dfd.promise;
}

/**
 * options = {
 *   "*dsmid": "datasyncmanagerid"
 * }
 */
function getParticularDataSyncManager(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  if (options && options.dsmid) {
    // Passed all validations, Contruct API url
    var adaptor = self.config.DEFAULT_HOSTS.AUTH,
      apiPath = self.config.AUTH_API_URLS.dataSyncManager,
      url = adaptor + apiPath;

    url = helpers.api.constructAPIUrl(url, {
      accountid: self.accountId, dsmid: options.dsmid
    });

    // Setup request with URL and Params
    var requestAPI = request.get(url);

    if (self.traceid) {
      requestAPI.set('X-Amzn-Trace-Id', self.traceid);
    }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
    });
  } else {
    var error = {};
    error.message = error.description = 'Mandatory params: dsmid not found in request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}

/**
 * options = {
 *   "*dsm_groupid": "datasyncmanagergroupid"
 * }
 */
function getAllDataSyncManagersOfAGroup(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  if (options && options.dsm_groupid) {
    // Passed all validations, Contruct API url
    var adaptor = self.config.DEFAULT_HOSTS.AUTH,
      apiPath = self.config.AUTH_API_URLS.getAllDataSyncManagersOfAGroup,
      url = adaptor + apiPath;

    url = helpers.api.constructAPIUrl(url, {
      accountid: self.accountId, dsm_groupid: options.dsm_groupid
    });

    // Setup request with URL and Params
    var requestAPI = request.get(url);

    if (self.traceid) {
      requestAPI.set('X-Amzn-Trace-Id', self.traceid);
    }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
  } else {
    var error = {};
    error.message = error.description = 'Mandatory params: dsm_groupid not found in request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}
